// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__9mBB2","spacer":"style_spacer__p5UXu"};